module.exports = __webpack_public_path__ + "img/notify_nav.2957cad7.jpg";